import React, { useState, useEffect, useContext } from "react"
import MonthPickerComponent from '../../../Utils/MonthPickerComponent'
import line from "../../../images/line.png"
import { TableDataContext } from '../../../Contexts/TableDataContext'
import SavedFilterContent from "../../../Components/SavedFilter";
import ExportPopup from "../../../Components/ExportPopup/FundsExcel";
import { fundsExportData } from "../../../Components/ExportPopup/ExportData"
import { exportFundsExcel } from "../../../Config/config";
import Constants from "../../../Constants";
import { PeFilterContext } from "../../../Contexts/PeFilterContext";
import { UserContext } from "../../../Contexts/UserContext";
import DownloadTrigger from "../../ExportPopup/DownloadTrigger";
function MainMenu(props) {

    const { save, showMonthPicker, groupId } = useContext(PeFilterContext);
    const { data } = useContext(TableDataContext);
    const [openTab, setOpenTab] = React.useState(1);
    const [showPopup, setShowPopup] = useState(false);
    const { isStudent, isTrialExport } = useContext(UserContext)

    useEffect(() => {
        setOpenTab(props.active)
    }, [openTab])

    return (
        <div className="pt-0 pl-3 pr-4">

            <div className="scrollbar  rounded">
                <div className=" py-2 rounded-b-none bg-white block lg:flex flex-row justify-end shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">

                    {groupId?.myList?.length > 0 ? "" :

                        <div className={"justify-between items-center px-4 space-x-4 " + (showMonthPicker != 0 ? 'md:flex' : 'flex')}>
                            {
                                data?.aggCount && data?.agg_raised_amt_usd ? (
                                    <h1 className="text-[#bc8b20] font-normal text-lg">
                                        Total No. of Funds <span className="font-semibold">{data?.aggCount}</span>; Amount (US$M) <span className="font-semibold">{data?.agg_raised_amt_usd}</span>
                                    </h1>
                                ) : null
                            }

                            <label htmlFor="" className="text-[#666666]">
                                <div className={showMonthPicker != 0 ? "" : 'flex'}>
                                    <MonthPickerComponent />
                                </div>
                            </label>
                            <div className={showMonthPicker != 0 ? "hidden md:flex space-x-3" : "flex space-x-3"}>
                                <a>
                                    <img
                                        className="h-[24px] max-w-[2px] mt-1 "
                                        src={line}
                                    />
                                </a>
                                {isTrialExport == 'false' || isStudent == 'true' ? <></> :
                                    <button>
                                        <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                        {showPopup && (
                                            <ExportPopup
                                                modules="funds"
                                                module_type="vc"
                                                fileName={props.exportFileName ?? Constants.exportNames.vc_funds}
                                                url={exportFundsExcel}
                                                onClose={() => setShowPopup(false)}
                                                exportOptions={fundsExportData}
                                            />
                                        )}
                                    </button>
                                }
                            </div>

                        </div>
                    }

                </div>
                {save ? <SavedFilterContent data={save} /> : ''}
            </div>
        </div>
    )
}

export default MainMenu
